/** The VALUE of a quoted literal's body: `\n` is a newline, not the letter n. */
export function unescapeStringLiteral(body: string): string {
  const single: Record<string, string> = {
    n: "\n",
    t: "\t",
    r: "\r",
    b: "\b",
    f: "\f",
    v: "\v",
    "0": "\0",
  };
  return body.replace(
    /\\(u\{([0-9a-fA-F]+)\}|u([0-9a-fA-F]{4})|x([0-9a-fA-F]{2})|.)/gs,
    (_, escape: string, braced?: string, unicode?: string, hex?: string) => {
      const code = braced ?? unicode ?? hex;
      if (code === undefined) return single[escape] ?? escape;
      const point = Number.parseInt(code, 16);
      // Out of range is not decodable: keep the source text rather than throw
      // inside a transcript row that only wants a label.
      return point <= 0x10ffff ? String.fromCodePoint(point) : `\\${escape}`;
    },
  );
}
